<template>
  <div
    class="tooth"
    v-click-outside="onCloseMenu">
    <tooth-popover-menu
      v-bind:value="isShowMenu"
      v-bind:flip="flip">
      <template slot="trigger">
        <div class="tooth__body">
          <button
            class="tooth__body__bone"
            type="button"
            v-bind:class="{ selected: isSelected('bone') }"
            v-bind:style="{ 'background-color': partColor['bone'] || '#ffead2' }"
            v-on:click="onClick('bone', $event)" />
          <button
            class="tooth__body__gingiva"
            type="button"
            v-bind:class="{ selected: isSelected('gingiva') }"
            v-bind:style="{ 'background-color': partColor['gingiva'] || '#f4ddc1' }"
            v-on:click="onClick('gingiva', $event)" />
          <button
            class="tooth__body__all-tooth"
            type="button"
            v-on:click="onAllToothClick($event)" />
          <svg
            v-if="!isDeleted"
            class="tooth-up-4 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 68 179">
            <g v-if="isDiagnosisImplant" id="implant">
              <rect width="25.564" height="13.231" x=".5" y="-.5" fill="#A8BEC5" stroke="#778F9F" rx="1.397" transform="matrix(1 0 0 -1 23.066 73.566)" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.764 56.976H25.932l4.836-55.777h11.904l4.092 55.777Z" />
              <rect width="29.845" height="4.309" x="21.425" y="56.501" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M23.268 52.317a1.68 1.68 0 0 0 1.94 1.373l23.52-4.033.168-.037a1.68 1.68 0 0 0-.736-3.274l-23.52 4.032a1.68 1.68 0 0 0-1.372 1.94Zm2.434-5.266.17-.02 22.176-3.696a1.68 1.68 0 1 0-.552-3.314L25.32 43.717l-.168.037a1.68 1.68 0 0 0 .55 3.297Zm.339-6.325.172-.02 21.84-3.696a1.68 1.68 0 0 0-.561-3.313l-21.84 3.695-.169.037a1.68 1.68 0 0 0 .558 3.297Zm-.759-7.729a1.68 1.68 0 0 0 1.93 1.386l20.496-3.36a1.68 1.68 0 0 0-.544-3.315l-20.496 3.36a1.68 1.68 0 0 0-1.386 1.929Zm2.142-4.925.17-.024 19.153-3.695a1.68 1.68 0 0 0-.636-3.3L26.957 24.75l-.166.04a1.68 1.68 0 0 0 .633 3.282Zm.671-5.988.17-.024 17.472-3.36.168-.041a1.68 1.68 0 0 0-.802-3.258L27.63 18.76l-.168.04a1.68 1.68 0 0 0 .632 3.284Zm.295-6.658.17-.02 16.128-2.688a1.68 1.68 0 1 0-.552-3.314l-16.128 2.688-.168.037a1.68 1.68 0 0 0 .55 3.297Zm.39-6.329.17-.025 15.12-3.024.167-.042a1.68 1.68 0 0 0-.827-3.253L28.29 5.777l-.167.042a1.68 1.68 0 0 0 .656 3.278Z" />
            </g>
            <g v-else>
              <path
                d="M25.639 51.7261C25.2107 53.6984 24.3316 66.125 23.9456 72.0918L48.3452 71.8774C47.6314 62.4806 45.6616 41.4147 44.805 32.3252C43.7343 20.9633 37.8453 7.67199 35.2755 3.92042C32.7058 0.168846 28.1016 -0.259903 29.1724 7.02886C30.2431 14.3176 29.0653 29.5383 28.637 33.5042C28.2087 37.4702 26.1743 49.2608 25.639 51.7261Z"
                v-bind:class="{ selected: isSelected('root_1') }"
                v-bind:fill="partColor['root_1'] || '#FFF'"
                v-on:click="onClick('root_1', $event)"
                v-on:keydown="onClick('root_1', $event)" />
              <path
                d="M39.3696 57.0475L40.3448 56.7985C40.7656 56.6911 41.1459 56.4633 41.4393 56.1431C41.9952 55.5363 42.1933 54.6857 41.9808 53.8908C38.0943 39.3549 37.7194 20.8828 36.7558 17.3913C36.7236 17.2747 36.6669 17.179 36.5901 17.0856C36.2934 16.7245 35.7413 16.6949 35.4443 17.0557C35.3427 17.1791 35.2696 17.2824 35.2711 17.3221C35.7653 30.4433 34.4988 47.4162 32.6568 54.8892L32.5144 55.5137C32.4047 55.9951 32.5531 56.499 32.9063 56.844C33.1098 57.0428 33.3683 57.1758 33.6483 57.2258L34.469 57.3724L35.9144 57.4298L37.3293 57.336L39.3696 57.0475Z"
                v-bind:class="{ selected: isSelected('central_canal') }"
                v-bind:fill="partColor['central_canal'] || '#FF82BE'"
                v-on:click="onClick('central_canal', $event)"
                v-on:keydown="onClick('central_canal', $event)" />
            </g>
            <path
              v-if="!isDiagnosisImplant || hasCrownOnImplant"
              d="M48.9873 87.0978C48.5469 89.1368 47.0592 91.3743 44.7125 93.5333C39.7765 98.0745 31.3401 97.8041 26.766 92.8985C23.5696 89.4705 22.161 85.4493 22.0923 80.7627C22.0535 78.1201 22.4701 75.1159 23.9452 72.0915C24.4248 71.1081 24.9856 70.1379 25.6387 69.1974C30.5212 62.1659 36.9527 63.052 39.5581 64.374C41.0928 65.3029 44.8115 68.2327 48.3449 71.8771C48.3449 71.8771 51.7588 74.2656 48.9873 87.0978Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
          <svg
            v-else-if="isBoneImplant"
            class="tooth-up-4 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 68 179">
            <g id="implant">
              <rect width="25.564" height="13.231" x=".5" y="-.5" fill="#A8BEC5" stroke="#778F9F" rx="1.397" transform="matrix(1 0 0 -1 23.066 73.566)" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.764 56.976H25.932l4.836-55.777h11.904l4.092 55.777Z" />
              <rect width="29.845" height="4.309" x="21.425" y="56.501" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M23.268 52.317a1.68 1.68 0 0 0 1.94 1.373l23.52-4.033.168-.037a1.68 1.68 0 0 0-.736-3.274l-23.52 4.032a1.68 1.68 0 0 0-1.372 1.94Zm2.434-5.266.17-.02 22.176-3.696a1.68 1.68 0 1 0-.552-3.314L25.32 43.717l-.168.037a1.68 1.68 0 0 0 .55 3.297Zm.339-6.325.172-.02 21.84-3.696a1.68 1.68 0 0 0-.561-3.313l-21.84 3.695-.169.037a1.68 1.68 0 0 0 .558 3.297Zm-.759-7.729a1.68 1.68 0 0 0 1.93 1.386l20.496-3.36a1.68 1.68 0 0 0-.544-3.315l-20.496 3.36a1.68 1.68 0 0 0-1.386 1.929Zm2.142-4.925.17-.024 19.153-3.695a1.68 1.68 0 0 0-.636-3.3L26.957 24.75l-.166.04a1.68 1.68 0 0 0 .633 3.282Zm.671-5.988.17-.024 17.472-3.36.168-.041a1.68 1.68 0 0 0-.802-3.258L27.63 18.76l-.168.04a1.68 1.68 0 0 0 .632 3.284Zm.295-6.658.17-.02 16.128-2.688a1.68 1.68 0 1 0-.552-3.314l-16.128 2.688-.168.037a1.68 1.68 0 0 0 .55 3.297Zm.39-6.329.17-.025 15.12-3.024.167-.042a1.68 1.68 0 0 0-.827-3.253L28.29 5.777l-.167.042a1.68 1.68 0 0 0 .656 3.278Z" />
            </g>
            <path
              v-if="hasCrownOnImplant"
              d="M48.9873 87.0978C48.5469 89.1368 47.0592 91.3743 44.7125 93.5333C39.7765 98.0745 31.3401 97.8041 26.766 92.8985C23.5696 89.4705 22.161 85.4493 22.0923 80.7627C22.0535 78.1201 22.4701 75.1159 23.9452 72.0915C24.4248 71.1081 24.9856 70.1379 25.6387 69.1974C30.5212 62.1659 36.9527 63.052 39.5581 64.374C41.0928 65.3029 44.8115 68.2327 48.3449 71.8771C48.3449 71.8771 51.7588 74.2656 48.9873 87.0978Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
        </div>
      </template>
      <form-teeth-formula-diagnoses
        v-bind:class="{ 'disable-component': disabled }"
        v-bind:is-deleted="needDeleted"
        v-bind:part-list="partList"
        v-bind:has-implant="hasImplant"
        v-on:cancel="onCloseMenu"
        v-on:change-diagnoses="onChangeDiagnoses"
        v-on:change-tooth-deleted="onChangeToothDeleted"
        v-on:submit="onSubmit" />
    </tooth-popover-menu>
    <top-tooth-surface
      v-bind:surface="surface"
      v-bind:part-selected="partSelected"
      v-bind:selected-parts="selectedParts"
      v-bind:flip="flip"
      v-on:select="onClick" />
    <div class="tooth__number">{{ tooth.number }}</div>
  </div>
</template>
<script>
import toothMixin from '@/mixins/toothMixin';
import TopToothSurface from '../TopToothSurface.vue';
import FormTeethFormulaDiagnoses from '../FormTeethFormulaDiagnoses.vue';
import ToothPopoverMenu from '../ToothPopoverMenu.vue';

export default {
  components: {
    TopToothSurface,
    FormTeethFormulaDiagnoses,
    ToothPopoverMenu,
  },
  name: 'ToothUp4',
  mixins: [toothMixin],
};
</script>

<style scoped></style>
